import { useForm } from 'react-hook-form';
import { DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CompanyUserFormFields } from './CompanyUserFormFields';
import type { EditUserFormData } from './EditUserForm.schema';

interface EditUserFormProps {
  register: ReturnType<typeof useForm<EditUserFormData>>['register'];
  handleSubmit: ReturnType<typeof useForm<EditUserFormData>>['handleSubmit'];
  errors: ReturnType<typeof useForm<EditUserFormData>>['formState']['errors'];
  setValue: ReturnType<typeof useForm<EditUserFormData>>['setValue'];
  watch: ReturnType<typeof useForm<EditUserFormData>>['watch'];
  submit: (data: EditUserFormData) => void;
  onClose: () => void;
  isLoading: boolean;
}

export function EditUserForm({
  register,
  handleSubmit,
  errors,
  setValue,
  watch,
  submit,
  onClose,
  isLoading,
}: EditUserFormProps): React.JSX.Element {
  return (
    <form onSubmit={handleSubmit(submit)} className="space-y-4">
      <CompanyUserFormFields
        firstNameProps={register('firstName')}
        lastNameProps={register('lastName')}
        phoneProps={register('phone')}
        errors={errors}
        selectedRole={watch('role')}
        onRoleChange={(v) => setValue('role', v)}
      />
      {errors.role && <p className="text-sm text-destructive">{errors.role.message}</p>}
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </DialogFooter>
    </form>
  );
}
